import React from "react";
import { inject, observer } from "mobx-react";
import { BestDropdown, FormColumn4Wide } from "best-common-react";

class VenueAdminFilters extends React.Component {
  render() {
    const { commonStore, venueAdminStore } = this.props.rootStore;
    return (
      <div className="row">
        <FormColumn4Wide>
          <BestDropdown
            id="year"
            title="Year"
            value={venueAdminStore.getSelectedYear}
            options={commonStore.activeYearsDropdownList}
            onChange={venueAdminStore.setSelectedYear}
          />
        </FormColumn4Wide>
      </div>
    );
  }
}

export default inject("rootStore")(observer(VenueAdminFilters));
